import { ActionType } from 'typesafe-actions';

import { IPlanListState } from '../interfaces/IPlanListState';
import * as actions from '../actions/planListActions';
import { PlanListActionsEnum } from '../enums/PlanListActionsEnum';

export type PlanListAction = ActionType<typeof actions>;

const initialState: IPlanListState = {
  data: [],
  page: 0,
  pageCount: 0,
  totalCount: 0,
  order: null,
  statuses: [],
  plan: null,
  approvedPlansForCurrentYear: [],
};

export function planListReducer(state = initialState, action: PlanListAction) {
  switch (action.type) {
    case PlanListActionsEnum.PLAN_LIST_SET_DATA: {
      const { data, page, totalCount, pageCount } = action.payload;
      const newState: IPlanListState = {
        ...state,
        data,
        page,
        pageCount,
        totalCount,
      };

      return newState;
    }
    case PlanListActionsEnum.PLAN_LIST_SET_ORDER: {
      const { order } = action.payload;
      const newState: IPlanListState = {
        ...state,
        order,
      };

      return newState;
    }
    case PlanListActionsEnum.PLAN_LIST_SET_STATUSES: {
      const { statuses } = action.payload;
      const newState: IPlanListState = {
        ...state,
        statuses,
      };

      return newState;
    }
    case PlanListActionsEnum.PLAN_LIST_SET_PLAN: {
      const { plan } = action.payload;
      const newState: IPlanListState = {
        ...state,
        plan,
      };

      return newState;
    }
    case PlanListActionsEnum.PLAN_LIST_SET_APPROVED_FOR_CURRENT_YEAR: {
      const { plans } = action.payload;
      const newState: IPlanListState = {
        ...state,
        approvedPlansForCurrentYear: plans,
      };

      return newState;
    }
    default:
      return state;
  }
}
